import { FC, PropsWithChildren } from 'react';

import { Icon } from '@eon-home/react-library';

import InfoIcon from '@assets/icons/emobility/info.svg';
import { composeClassName } from '@tools/utils';

import './index.scss';

export interface Props {
    showInfoIcon?: boolean;
    useRoundedCorners?: boolean;
    centerContent?: boolean;
}

export const Infobox: FC<Readonly<PropsWithChildren<Props>>> = ({
    children,
    showInfoIcon = false,
    useRoundedCorners = false,
    centerContent = false,
}) => {
    return (
        <div
            className={composeClassName('c-infobox', [
                useRoundedCorners ? 'rounded' : '',
            ])}
        >
            {showInfoIcon && <Icon src={InfoIcon} />}

            <div
                className={composeClassName('c-infobox__content', [
                    centerContent ? 'centered' : '',
                ])}
            >
                {children}
            </div>
        </div>
    );
};

export default Infobox;
